<template>
  <label class="bbe-checkbox" @click.stop>
    <span class="bbe-checkbox-container">
      <input class="bbe-checkbox-container__input"
             v-model="statusCheckbox"
             type="checkbox"
             :disabled="disabled"
             :name="name">
       <span class="bbe-checkbox-container__mark-wrapper">
        <i class="email-icon-check bbe-checkbox-container__mark"/>
      </span>
    </span>
  </label>
</template>
<script>
export default {
  name: 'checkboxBE',
  props: ['value', 'name', 'section', 'disabled'],
  computed: {
    statusCheckbox: {
      get: function () {
        return this.value
      },
      set: function (data) {
        this.$emit('checkboxChange', data, this.name, this.section)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";

  .bbe-checkbox {
    position: relative;
    display: inline-flex;
    min-height: 15px;

    &-container {
      position: relative;
      cursor: pointer;
      width: 15px;
      min-width: 15px;

      &__mark-wrapper {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 15px;
        width: 15px;
        border: 1px solid $color-accent;
        box-sizing: border-box;
        border-radius: 3px;
        transition: .15s ease-out;
      }

      &__mark {
        font-size: 0;
        color: $color-white;
        transition: .15s ease-out;
      }

      &__input {
        position: absolute;
        top: 0;
        left: 0;
        height: 15px;
        width: 15px;
        margin: 0;
        opacity: 0;

        &:checked + span {
          background-color: $color-accent;

          i {
            font-size: 9px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/FormsElements/checkbox.vue